import { useState } from "react";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL } from "@/mocks/categories";

const FAQ_ITEMS = ["1", "2", "3", "4", "5", "6", "7", "8"];

export default function FaqSection() {
  const { t } = useTranslation();
  const [open, setOpen] = useState<string | null>("1");

  return (
    <>
      <section id="faq" className="scroll-mt-24">
        <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-16">
          <div className="mx-auto max-w-3xl text-center">
            <h2 className="text-2xl font-bold text-foreground-950 md:text-3xl">
              {t("home.faq.title")}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              {t("home.faq.subtitle")}
            </p>
          </div>

          <div className="mx-auto mt-10 max-w-3xl space-y-3">
            {FAQ_ITEMS.map((n) => {
              const isOpen = open === n;
              return (
                <div
                  key={n}
                  className="overflow-hidden rounded-xl border border-background-200 bg-white"
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : n)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    aria-expanded={isOpen}
                  >
                    <span className="text-sm font-semibold text-foreground-900 md:text-base">
                      {t(`home.faq.q${n}`)}
                    </span>
                    <i
                      className={`shrink-0 text-lg text-foreground-400 transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                      aria-hidden="true"
                    ></i>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5">
                      <p className="text-sm leading-relaxed text-foreground-600">
                        {t(`home.faq.a${n}`)}
                      </p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section className="mx-auto max-w-7xl px-4 pb-4 md:px-6">
        <div className="relative overflow-hidden rounded-3xl bg-primary-600 px-6 py-12 text-center md:px-12 md:py-16">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -right-20 -top-20 h-64 w-64 rounded-full bg-white/10 blur-2xl"
          />
          <div
            aria-hidden="true"
            className="pointer-events-none absolute -bottom-20 -left-20 h-64 w-64 rounded-full bg-accent-500/30 blur-2xl"
          />
          <div className="relative mx-auto max-w-2xl">
            <h2 className="text-2xl font-bold text-white md:text-3xl">
              {t("home.finalCta.title")}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-white/85 md:text-base">
              {t("home.finalCta.subtitle")}
            </p>
            <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100 cursor-pointer"
              >
                {t("home.finalCta.primary")}
                <i className="ri-arrow-right-up-line" aria-hidden="true"></i>
              </a>
              <a
                href={MAIN_SITE_URL}
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-white/40 px-7 py-3.5 text-sm font-semibold text-white transition-colors hover:bg-white/10 cursor-pointer"
              >
                {t("home.finalCta.secondary")}
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}